import React from "react";
import AdminShell from "../components/AdminShell.jsx";

export default function AdminTorneosIndex() {
  return (
    <AdminShell>
      <h3 className="mb-3">Torneos</h3>
      <p>Listado de torneos (placeholder).</p>
    </AdminShell>
  );
}
